export const isPeriodRef = (ref) => ref.kind === "period";
export const isCurveRef = (ref) => ref.kind === undefined || ref.kind === "curve";
//# sourceMappingURL=gridSelection.js.map